import {
  REQUEST_FEATURE_FLAGS,
  REQUEST_FEATURE_FLAGS_ERROR,
  REQUEST_FEATURE_FLAGS_SUCCESS,
} from "../action/launchDarklyFeatureFlags-action";

const initialState = {
  loading: false,
  featureFlags: undefined,
};

export const LaunchDarklyFeatureFlagReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_FEATURE_FLAGS_SUCCESS:
      return {
        ...state,
        featureFlags: action.payload,
        loading: false,
      };
    case REQUEST_FEATURE_FLAGS_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        unauthorized: action.payload,
      };
    case REQUEST_FEATURE_FLAGS:
      return {
        ...state,
        loading: true,
      };
    default:
      return state;
  }
}
